/**
 * Telefone como se lê, para exibir (não para digitar). O número chega do WhatsApp cru, com o
 * código do país: "554195548806" vira "(41) 9554-8806". Número de outro país ganha só o "+";
 * o que não parece telefone volta como veio.
 */
export const telefoneLegivel = (bruto?: string | null): string => {
    const original = (bruto ?? '').trim();
    let d = original.replace(/\D/g, '');
    if (!d) return original;

    if (d.startsWith('55') && (d.length === 12 || d.length === 13)) d = d.slice(2);

    if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
    if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    if (d.length > 11 && d.length <= 15) return `+${d}`;
    return original;
};
